import { render } from "./MomentExcitement.vue?vue&type=template&id=46232800&scoped=true"
import script from "./MomentExcitement.vue?vue&type=script&lang=js"
export * from "./MomentExcitement.vue?vue&type=script&lang=js"

import "./MomentExcitement.vue?vue&type=style&index=0&id=46232800&lang=scss&scoped=true"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mguoxueweb_online/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46232800"]])

export default __exports__